// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icons_bYpxx, .title_q0Yc8, .accessories_P0yP7 { 
  display : -webkit-inline-box; 
  display : -ms-inline-flexbox; 
  display : inline-flex;
  -webkit-box-orient : horizontal;
  -webkit-box-direction : normal;
      -ms-flex-direction : row;
          flex-direction : row;
  -webkit-box-align : center;
      -ms-flex-align : center;
          align-items : center;
}

.title_q0Yc8 { 
  pointer-events: none;
  justify-items : left;
}

.accessories_P0yP7 { 
  justify-items : right;
}

.icons_bYpxx {
  pointer-events: none;
  justify-items : left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.item_gcSbH {
  border : none;
  background-color : transparent;
  padding : 0;
  padding : initial;
  cursor : inherit;
}

.checkedItem_kI5hl {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  justify-items: left;
}

.checkedItem_kI5hl > .title_q0Yc8 > :first-child {
  margin-right : 8px;
}

.checkedItemElement_hAKiB {
  display : -webkit-box;
  display : -ms-flexbox;
  display : flex;
}

.menu_oQax1, .item_gcSbH {
  display: grid !important;
  grid-template-columns: auto 1fr auto;
  /* justify-content: space-between !important; */
  -webkit-box-align: center !important;
      -ms-flex-align: center !important;
          align-items: center !important;
}

.popup_IP3Ku {
  max-height: 80vh;
  max-width: 80vw;
  width: auto;
  overflow: auto;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.stickyHeader_nJjfX { /* Safari */
  position: sticky;
  top: 0;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Popup.css"],"names":[],"mappings":"AAAA;EACE,4BAAqB;EAArB,4BAAqB;EAArB,qBAAqB;EACrB,+BAAoB;EAApB,8BAAoB;MAApB,wBAAoB;UAApB,oBAAoB;EACpB,0BAAoB;MAApB,uBAAoB;UAApB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAe;EAAf,iBAAe;EACf,gBAAc;AAChB;;AAEA;EACE,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,8BAAmB;EAAnB,6BAAmB;MAAnB,uBAAmB;UAAnB,mBAAmB;EACnB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,+CAA+C;EAC/C,oCAA8B;MAA9B,iCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,cAAc;EACd,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,sBAC4B,WAAW;EACrC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ","sourcesContent":[".icons, .title, .accessories { \n  display : inline-flex;\n  flex-direction : row;\n  align-items : center;\n}\n\n.title { \n  pointer-events: none;\n  justify-items : left;\n}\n\n.accessories { \n  justify-items : right;\n}\n\n.icons {\n  pointer-events: none;\n  justify-items : left;\n  display: flex;\n  align-items: center;\n}\n\n.item {\n  border : none;\n  background-color : transparent;\n  padding : unset;\n  cursor : unset;\n}\n\n.checkedItem {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  justify-items: left;\n}\n\n.checkedItem > .title > :first-child {\n  margin-right : 8px;\n}\n\n.checkedItemElement {\n  display : flex;\n}\n\n.menu, .item {\n  display: grid !important;\n  grid-template-columns: auto 1fr auto;\n  /* justify-content: space-between !important; */\n  align-items: center !important;\n}\n\n.popup {\n  max-height: 80vh;\n  max-width: 80vw;\n  width: auto;\n  overflow: auto;\n  user-select: none;\n}\n\n.stickyHeader {\n  position: -webkit-sticky; /* Safari */\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icons": `icons_bYpxx`,
	"title": `title_q0Yc8`,
	"accessories": `accessories_P0yP7`,
	"item": `item_gcSbH`,
	"checkedItem": `checkedItem_kI5hl`,
	"checkedItemElement": `checkedItemElement_hAKiB`,
	"menu": `menu_oQax1`,
	"popup": `popup_IP3Ku`,
	"stickyHeader": `stickyHeader_nJjfX`
};
export default ___CSS_LOADER_EXPORT___;
